import GraphemeSplitter from 'grapheme-splitter';

import { useAppSelector } from '@pkg/hooks';

const FREE_YAT_LENGTH = 6;

const checkLength = (emojiStr: string): number => {
    const grapheme = new GraphemeSplitter();
    return grapheme.splitGraphemes(emojiStr).length;
};

export const useHasFreeYat = () => {
    const userEmojis = useAppSelector((state) => state.userEmojis);

    return (
        userEmojis &&
        userEmojis.emojis[0] &&
        userEmojis?.emojis.length === 1 &&
        checkLength(userEmojis.emojis[0]) === FREE_YAT_LENGTH
    );
    // Only 1 yat and 6 emojis is a free Yat.
};
